import { useState } from "react";
import { motion } from "framer-motion";
import { CaretDown } from "@phosphor-icons/react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { useSeo } from "../hooks/useSeo";

const services = [
  {
    category: "Beratung",
    items: [
      { name: "Beratung Haarfarbe", price: "25 €", description: "" },
      { name: "Beratung Haarverlängerung / Verdichtung", price: "25 €", description: "Professionelle Beratung für Extensions, Tressen und Haarverdichtung in Heilbronn." },
    ],
  },
  {
    category: "Blond & Balayage",
    note: "Alle Blond-Services beinhalten Glossing/Toner, Pflege, Finish & Styling.",
    items: [
      { name: "Signature Blond & Balayage Session", price: "290 €", description: "Für komplette Blondveredelung (Ansatz bis Längen) – individuell auf dein Haar abgestimmt. Premium Balayage Heilbronn." },
      { name: "AirTouch Strähnentechnik", price: "349 €", description: "Die beliebte AirTouch-Technik für sanfte, natürliche Farbübergänge. AirTouch Spezialist Heilbronn." },
      { name: "Ansatz Folien – Quick Fresh-up", price: "140 €", description: "" },
      { name: "Ansatz Folien – Oberkopf / Kontur", price: "175 €", description: "" },
      { name: "Ansatz Folien – Komplett", price: "225 €", description: "" },
      { name: "Babylights – Oberkopf", price: "190 €", description: "" },
      { name: "Babylights – Komplett", price: "249 €", description: "" },
      { name: "Bleach & Gloss (Ansatzblondierung)", price: "ab 149 €", description: "Gilt bis max. 3 cm Rauswuchs." },
      { name: "Paintings / Freehand Balayage – Oberkopf", price: "140 €", description: "" },
      { name: "Paintings / Freehand Balayage – Ansatz komplett", price: "165 €", description: "" },
      { name: "Paintings / Freehand Balayage – Komplett", price: "195 €", description: "" },
    ],
  },
  {
    category: "Farbe",
    items: [
      { name: "Color & Go", price: "45 €", description: "Auftragen im Salon, Einwirkzeit – Ausspülen zu Hause." },
      { name: "Haarfarbe (Ansatz) inkl. Styling", price: "85 €", description: "" },
      { name: "Haarfarbe komplett inkl. Styling", price: "150 €", description: "" },
    ],
  },
  {
    category: "Schnitt",
    items: [
      { name: "Schnitt & Styling", price: "65 €", description: "" },
    ],
  },
  {
    category: "Keratin",
    items: [
      { name: "Keratin Glättung", price: "125 € / Stunde", description: "Meistens 2–2,5 Stunden (je nach Haarlänge, Dichte und Ausgangslage)." },
    ],
  },
  {
    category: "Haarverlängerung & Verdichtung",
    items: [
      { name: "Tressen / Wefts einsetzen", price: "auf Anfrage", description: "Professionelle Haarverlängerung mit Tressen in Heilbronn. Natürliche Ergebnisse, schonende Technik." },
      { name: "Tresse liften / hochsetzen", price: "25 € je angefangene 15 Min", description: "" },
      { name: "Haarverdichtung", price: "auf Anfrage", description: "Mehr Volumen und Fülle durch professionelle Haarverdichtung." },
    ],
  },
  {
    category: "Beauty",
    items: [
      { name: "All in (Brow zupfen & färben, Lashes färben, Oberlippe)", price: "43 €", description: "" },
      { name: "Augenbrauen zupfen & färben", price: "28 €", description: "" },
      { name: "Augenbrauen zupfen (Faden)", price: "11 €", description: "" },
    ],
  },
];

const ServicesPage = () => {
  const [openCategory, setOpenCategory] = useState("Blond & Balayage");

  useSeo({
    title: "Services & Preise | Balayage, AirTouch & Haarverlängerung Heilbronn | JS Blond Salon",
    description: "Alle Leistungen & Preise im JS Blond Salon Leingarten/Heilbronn: Balayage, AirTouch, Blondierung, Glossing, Haarverlängerung & Haarverdichtung. Transparente Preise, ehrliche Beratung.",
    path: "/services",
  });


  return (
    <div className="min-h-screen bg-[#F9F7F2]">
      <Navigation />
      
      {/* Hero */}
      <section className="pt-32 pb-16 bg-white">
        <div className="container-padding">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <span className="caption block mb-4">Blond, AirTouch & Haarverlängerung Heilbronn</span>
              <h1
                className="text-5xl md:text-6xl font-normal tracking-tight mb-6"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Service & Preise
              </h1>
              <p className="text-lg leading-relaxed font-light text-[#2C2C2C]/70">
                <strong className="font-medium text-[#2C2C2C]">Ihr Blond-Spezialist in Heilbronn/Leingarten</strong> – Balayage, AirTouch, Haarverlängerung & Verdichtung.
                <br /><br />
                Alle Preise richten sich nach Zeitaufwand, Haarlänge, Haardichte und Ausgangsbasis.
                Mehrzeit wird mit 45 € pro weitere 30 Minuten berechnet.
                <br /><br />
                <strong className="font-medium text-[#2C2C2C]">Termine ausschließlich nach Vereinbarung.</strong>
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="hidden lg:block"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_1a92d488-6b73-421e-b552-cb97ed3d4201/artifacts/ux144oee_IMG_8663.jpeg"
                alt="JS Blond Salon – Premium Bedienplätze"
                className="w-full h-[380px] object-cover rounded-lg"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Services List */}
      <section className="section-spacing bg-[#F9F7F2]">
        <div className="container-padding">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Services Accordion */}
            <div className="lg:col-span-2">
              {services.map((category, categoryIndex) => (
                <motion.div
                  key={category.category}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: categoryIndex * 0.05 }}
                  className="border-b border-[#E6E2D6] bg-white"
                >
                  <button
                    onClick={() => setOpenCategory(openCategory === category.category ? "" : category.category)}
                    data-testid={`service-category-${categoryIndex}`}
                    className="w-full py-6 px-6 flex items-center justify-between text-left"
                  >
                    <h3
                      className="text-xl md:text-2xl font-medium"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      {category.category}
                    </h3>
                    <CaretDown 
                      size={24} 
                      className={`text-[#9A8C73] transition-transform duration-300 ${
                        openCategory === category.category ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  <motion.div
                    initial={false}
                    animate={{
                      height: openCategory === category.category ? "auto" : 0,
                      opacity: openCategory === category.category ? 1 : 0,
                    }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="pb-6 px-6">
                      {category.note && (
                        <p className="text-sm text-[#9A8C73] mb-4 italic">
                          {category.note}
                        </p>
                      )}
                      <div className="space-y-4">
                        {category.items.map((item, itemIndex) => (
                          <div
                            key={itemIndex}
                            data-testid={`service-item-${categoryIndex}-${itemIndex}`}
                            className="flex justify-between items-start gap-4 py-3 border-b border-[#F2EFE9] last:border-0"
                          >
                            <div className="flex-1">
                              <p className="font-medium text-[#2C2C2C]">{item.name}</p>
                              {item.description && (
                                <p className="text-sm text-[#2C2C2C]/60 mt-1">{item.description}</p>
                              )}
                            </div>
                            <span className="text-[#9A8C73] font-semibold whitespace-nowrap text-lg">
                              {item.price}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </motion.div>
                </motion.div>
              ))}
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <div className="sticky top-28 space-y-6">
                {/* Book CTA */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  className="bg-[#2C2C2C] text-white p-8"
                >
                  <h3
                    className="text-xl font-medium mb-4"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    Termin buchen
                  </h3>
                  <p className="text-white/70 text-sm mb-6">
                    Termine können 24h online gebucht werden. Eine verbindliche 
                    Preiseinschätzung erfolgt nach individueller Beratung.
                  </p>
                  <a
                    href="https://www.phorest.com/salon/jsblondsalonughaftungsbeschrae"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="services-book-btn"
                    className="block w-full bg-[#D4AF37] text-[#2C2C2C] py-4 text-center uppercase tracking-widest text-xs font-bold hover:bg-white transition-colors"
                  >
                    Jetzt buchen
                  </a>
                </motion.div>

                {/* Info Box */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 }}
                  className="bg-[#D4AF37]/10 p-6 border-l-4 border-[#D4AF37]"
                >
                  <h4 className="font-medium text-[#2C2C2C] mb-2">Wichtig bei Ansatzfolien:</h4>
                  <p className="text-sm text-[#2C2C2C]/70">
                    Wenn dein letzter Strähnentermin länger als 6 Monate her ist, 
                    buche bitte die Signature Blond & Balayage Session, da der 
                    Aufwand deutlich höher ist.
                  </p>
                </motion.div>

                {/* Image */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.2 }}
                >
                  <img
                    src="https://static.wixstatic.com/media/5071cb_b5f02cdea93940e5b0dc91478a93879f~mv2.jpeg/v1/fill/w_500,h_600,fp_0.66_0.30,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Hair-Vol01-MakeStories-58.jpeg"
                    alt="Blond Service"
                    className="w-full h-[300px] object-cover"
                  />
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
